module.exports = __webpack_public_path__ + "a20ede3ea7c094365f7e51120e987fe1.jpg";